import React, { Component } from "react"
import { Col, Container, Modal, Row, Tab, Tabs } from "react-bootstrap"
import GeneralInfo from "./EmployeeDetails/GeneralInfo"
import CurrentService from "./EmployeeDetails/CurrentService"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import CurrentServiceHistory from "./EmployeeDetails/CurrentServiceHistory"

const GeneralInfoKey = "general-info"
const ServiceKey = "service"
const TestingHistoryKey = "testing-history"


interface EmployeeDetailsModalProps {
  details?: OrderResultRecord
  personID: number
  poolID?: number
  poolName?: string
  name: string
  id: string
  showService?: boolean
  onHide: (updated: boolean) => void
  isGov?: boolean
}

interface EmployeeDetailsModalState {
  currentTab: string
  updated: boolean
}

export default class EmployeeDetailsModal extends Component<EmployeeDetailsModalProps, EmployeeDetailsModalState> {
  state: EmployeeDetailsModalState = { currentTab: GeneralInfoKey, updated: false }

  render() {
    const { details, showService, personID, poolID, poolName, name, id, isGov } = this.props
    const modalHeader = isGov ? "DONOR DETAILS" : "EMPLOYEE DETAILS"
    return (
      <Modal show onHide={() => this.props.onHide(this.state.updated)} size="xl" dialogClassName="dark">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>{modalHeader}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <Container className="tab-container p-0">
            <Row className="px-0 pt-2">
              <Col>
                <h4 className="px-4">
                  <span className="text-uppercase">{name}</span> - {id}
                </h4>
                <Tabs
                  defaultActiveKey={GeneralInfoKey}
                  activeKey={this.state.currentTab}
                  className="px-4 py-2"
                  onSelect={(eventKey) => {
                    eventKey && this.setState({ currentTab: eventKey })
                  }}
                >
                  <Tab eventKey="general-info" title="GENERAL INFORMATION" tabClassName="rounded-pill px-4">
                    {GeneralInfoKey === this.state.currentTab && (
                      <GeneralInfo
                        PersonID={personID}
                        isGov={isGov}
                        onUpdate={() => this.setState({ updated: true })}
                      />
                    )}
                  </Tab>
                  {showService && details && (
                    <Tab eventKey="service" title="CURRENT SERVICE DETAILS" tabClassName="rounded-pill px-4">
                      {ServiceKey === this.state.currentTab && <CurrentService details={details} />}
                    </Tab>
                  )}
                  {!isGov && !showService && (
                    <Tab eventKey={TestingHistoryKey} title="CURRENT SERVICE DETAILS" tabClassName="rounded-pill px-4">
                      {TestingHistoryKey === this.state.currentTab && (
                        <CurrentServiceHistory
                          PersonID={personID}
                          PoolID={poolID}
                          PoolName={poolName}
                          isOntrack={isGov}
                        />
                      )}
                    </Tab>
                  )}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    )
  }
}
